module.exports = __webpack_public_path__ + "img/VASCO-fond-blanc-ang-584x584.0bc827ed.webp";